import { io } from "socket.io-client";

let socket;

export const getSocket = (url) => {

  if (!socket) {
    socket = io(url, {
      transports: ["websocket"],
      reconnection: true,
    });

    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });
  }
  return socket;
};